module.exports = __webpack_public_path__ + "static/media/marina-main-payment.c7b2f134.png";